import { render, staticRenderFns } from "./EditableDescription.vue?vue&type=template&id=18d4d0e1&scoped=true"
import script from "./EditableDescription.vue?vue&type=script&lang=js"
export * from "./EditableDescription.vue?vue&type=script&lang=js"
import style0 from "./EditableDescription.vue?vue&type=style&index=0&id=18d4d0e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d4d0e1",
  null
  
)

export default component.exports